import { MOBILE_URLS } from '@/router/routes/urlMobileRoutes'
import { UserType } from '@/store/modules/auth/authTypes'

export const mobileRoutes = [
  {
    path: `/${ MOBILE_URLS.HOME }`,
    name: MOBILE_URLS.HOME,
    component: () => import('@/views/Mobile/MobileHomeView.vue'),
    meta: {
      title: MOBILE_URLS.HOME,
      requiresAuth: true,
      mobile: true,
      userType: [UserType.MOBILE]
    },
    children: [
      {
        path: `/${ MOBILE_URLS.EXPEDIENTS }`,
        name: MOBILE_URLS.EXPEDIENTS,
        component:  () => import('@/views/Mobile/MobileExpedientListView.vue'),
        meta: {
          title: MOBILE_URLS.EXPEDIENTS,
          mobile: true,
          userType: [UserType.MOBILE]
        }
      },
      {
        path: `/${ MOBILE_URLS.EXPEDIENTS}/:selectedExpedientId`,
        name: MOBILE_URLS.EXPEDIENT_DETAIL,
        component: () => import('@/views/Mobile/MobileExpedientDetailView.vue'),
        props: (route: { params: { selectedExpedientId: string } }) => ({
          id: route.params.selectedExpedientId,
        }),
        meta: {
          title: MOBILE_URLS.EXPEDIENT_DETAIL,
          mobile: true,
          userType: [UserType.MOBILE]
        }
      },
      {
        path: `/${ MOBILE_URLS.DOCUMENTS }`,
        name: MOBILE_URLS.DOCUMENTS,
        component:  () => import('@/views/Mobile/MobileDocumentListView.vue'),
        meta: {
          title: MOBILE_URLS.DOCUMENTS,
          mobile: true,
          userType: [UserType.MOBILE]
        }
      }
    ]
  }
]
